import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { ListMapComponent } from '@map/list-map.component';
import { StaticMapComponent } from '@map/static-map.component';
import { BazisMapModule } from '@bazis/map/map.module';
import { MapComponent } from '@map/map.component';
import { LassoComponent } from '@map/components/controls/lasso.component';
import { MapEditableComponent } from '@map/map-editable.component';
import { EditableMapService } from '@map/services/editable-map.service';
import { DrawPolygonComponent } from '@map/components/controls/draw-polygon.component';
import { DrawLineComponent } from '@map/components/controls/draw-line.component';
import { DrawTransformComponent } from '@map/components/controls/transform.component';
import { MapSearchComponent } from '@map/components/controls/search.component';
import { ResizeMapControlComponent } from '@map/components/controls/resize.component';
import { InfiniteListComponent } from '@bazis/shared/components/infinite-list.component';

const DECLARATIONS = [
    StaticMapComponent,
    ListMapComponent,
    MapComponent,
    LassoComponent,
    MapEditableComponent,
    DrawPolygonComponent,
    DrawLineComponent,
    DrawTransformComponent,
    ResizeMapControlComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        TranslocoModule,
        BazisMapModule,
        MapSearchComponent,
        InfiniteListComponent,
    ],
    exports: [...DECLARATIONS, BazisMapModule],
    declarations: [...DECLARATIONS],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: ['map'],
        },
        EditableMapService,
    ],
})
export class MapModule {}
